import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  titleContainer: {
    backgroundColor: getBrandCustom("subHeaderBackgroundColor", "#F8F9FC"),
    height: "64px",
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    marginBottom: "24px",
    marginTop: "-15px",
    marginLeft: "-32px",
    width: "calc(100% + 64px)",
    padding: "0px 32px",
  },
  titleDataContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
  },
  title: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    color: getBrandCustom("primaryColor", "#38CFC4"),
  },
  titleData: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "13px",
    lineHeight: "16px",
  },
}));

export default styles;
